import React, { useEffect } from "react"

export const SnowEffect = () => {
    const snowflakes_count = 200
    const base_css = ``

    const random_int = (value = 100) => Math.floor(Math.random() * value) + 1

    const random_range = (min: number, max: number) => {
        min = Math.ceil(min)
        max = Math.floor(max)
        return Math.floor(Math.random() * (max - min + 1)) + min
    }

    // Append style for each snowflake to the head
    const add_css = (rule: string) => {
        const css = document.createElement("style")
        css.type = "text/css"
        css.appendChild(document.createTextNode(rule)) // Support for the rest
        document.getElementsByTagName("head")[0].appendChild(css)
    }

    // Create style for snowflake
    const spawnSnowCSS = (snow_density = 200) => {
        const snowflake_name = "snowflake"
        let rule = ``
        if (typeof base_css !== "undefined") {
            rule = base_css
        }

        for (let i = 1; i < snow_density; i++) {
            const random_x = Math.random() * 100 // vw
            const random_offset = random_range(-100000, 100000) * 0.0001 // vw;
            const random_x_end = random_x + random_offset
            const random_x_end_yoyo = random_x + random_offset / 2
            const random_yoyo_time = random_range(30000, 80000) / 100000
            const random_yoyo_y = random_yoyo_time * 100 // vh
            const random_scale = Math.random()
            const fall_duration = random_range(10, 30) * 1 // s
            const fall_delay = random_int(30) * -1 // s
            const opacity_ = Math.random()

            rule += `
        .${snowflake_name}:nth-child(${i}) {
            opacity: ${opacity_};
            transform: translate(${random_x}vw, -10px) scale(${random_scale});
            animation: fall-${i} ${fall_duration}s ${fall_delay}s linear infinite;
        }

        @keyframes fall-${i} {
            ${random_yoyo_time * 100}% {
                transform: translate(${random_x_end}vw, ${random_yoyo_y}vh) scale(${random_scale});
            }

            to {
                transform: translate(${random_x_end_yoyo}vw, 100vh) scale(${random_scale});
            }
            
        }
        `
        }

        add_css(rule)
    }

    // Creating snowflakes
    const spawn_snow = (snow_density = 200) => {
        snow_density -= 1

        for (let x = 0; x < snow_density; x++) {
            const board = document.createElement("div")
            board.className = "snowflake"
            document.getElementById("snow")?.appendChild(board)
        }
    }

    useEffect(() => {
        spawnSnowCSS(snowflakes_count)
        spawn_snow(snowflakes_count)
    }, [])

    return <></>
}
